module.exports = __webpack_public_path__ + "static/img/30-北京大学附属中学.2beb968.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/30-北京大学附属中学.png
// module id = Bogp
// module chunks = 0